import { Stack } from 'expo-router';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';

import {
    adminUserAtom,
    selectedMembershipIdAtom,
} from '../../entities/entityAtoms';
import { AdminUserRole } from '../../entities/entityTypes';
import { GenericHome } from '../../home/components/GenericHome';
import { GuideHome } from '../../home/components/GuideHome';

export default function IndexPage() {
    const adminUser = useAtomValue(adminUserAtom);
    const setSelectedMembershipId = useSetAtom(selectedMembershipIdAtom);

    useEffect(() => {
        setSelectedMembershipId(null);
    }, []);

    const showGuideHome = [
        AdminUserRole.GUIDE,
        AdminUserRole.GUIDE_LEAD,
    ].includes(adminUser.role);

    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Home',
                    headerLeft: () => null, // Prevents back button from showing on Home page, cause it kinda doesn't make sense
                }}
            />
            {showGuideHome ? <GuideHome /> : <GenericHome />}
        </>
    );
}
